var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"spinner",style:({ minHeight: `${_vm.minHeight}vh` })},[_c('div',{staticClass:"bounce1 mx-1"}),_c('div',{staticClass:"bounce2 mx-1"}),_c('div',{staticClass:"bounce3 mx-1"})])
}
var staticRenderFns = []

export { render, staticRenderFns }